export const CHECK_EMP_SLOT_TYPES = "CHECK_EMP_SLOT_TYPES";
export const GET_EMP_SLOT = "GET_EMP_SLOT";
export const GET_EMP_TIME_SLOT = "GET_EMP_TIME_SLOT";
export const GET_EMP_DEVICES = "GET_EMP_DEVICES";
export const VERIFY_UPLOAD_EMP_DOC = "VERIFY_UPLOAD_EMP_DOC";
export const VERIFY_UPLOAD_DEVICE_COMMAND_DOC =
  "VERIFY_UPLOAD_DEVICE_COMMAND_DOC";
export const VERIFY_EMP_DEVICE = "VERIFY_EMP_DEVICE";
export const SET_EMP_LOCK_DEVICE = "SET_EMP_LOCK_DEVICE";
export const SEAL_DEVICES = "SEAL_DEVICES";
export const UNSEAL_DEVICES = "UNSEAL_DEVICES";
export const CANCEL_BOOK_SLOT = "CANCEL_BOOK_SLOT";
export const START_DEVICE_TESTING = "START_DEVICE_TESTING";
export const VERIFY_MANUAL_TESTING = "VERIFY_MANUAL_TESTING";
export const SEND_COMMAND = "SEND_COMMAND";
export const TESTING_DEVICE_ACTV = "TESTING_DEVICE_ACTV";
export const TESTING_DEVICE_HCHK = "TESTING_DEVICE_HCHK";
export const OTHER_INFO = "OTHER_INFO";
export const VERIFY_OTHER_INFO = "VERIFY_OTHER_INFO";
export const GET_PBG = "GET_PBG";
export const VERIFY_PBG = "VERIFY_PBG";
export const VERIFY_BG_DETAIL = "VERIFY_BG_DETAIL";
export const SET_EMPANELED = "SET_EMPANELED";
export const GENERATE_EMPANELED = "GENERATE_EMPANELED";
export const GENERATE_RFC_EMPANELED = "GENERATE_RFC_EMPANELED";
export const GET_EMP_RFC_DETAIL = "GET_EMP_RFC_DETAIL";
export const VERIFY_EMP_RFC = "VERIFY_EMP_RFC";
export const PENDING_RFC_DISTRICT = "PENDING_RFC_DISTRICT";
export const GET_EMP_RFC_EXCEL_DETAIL = "GET_EMP_RFC_EXCEL_DETAIL";
export const ACTIVE_TAB = "ACTIVE_TAB";
export const GET_EMPANELMENT_OTHER_DOCUMENT = "GET_EMPANELMENT_OTHER_DOCUMENT";
export const SET_EMPANELMENT_OTHER_DOCUMENT = "SET_EMPANELMENT_OTHER_DOCUMENT";
